import { ElementRef } from '@angular/core';

export function invalidControlScroll(elementRef: ElementRef) {
    const firstInvalidControl: HTMLElement = elementRef.nativeElement.querySelector('.invalidFeedback');

    firstInvalidControl?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    firstInvalidControl?.focus({ preventScroll: true });
}
